import React, { useEffect, useRef } from 'react';
import { useForm } from 'components/form/Form';
import { classNames } from 'libs/react';
import { useValue } from 'components/form/hook/useValue';
import { useIdent } from 'libs/react';
import { useIf } from 'libs/react';
import { useState } from 'libs/react';
import { useWatch } from 'libs/react';
import { FormFieldError } from 'components/form/FormFieldError';
import { FormFieldInfos } from 'components/form/FormFieldInfos';
import { FormFieldLabel } from 'components/form/FormFieldLabel';
import { Icon } from 'components/Icon';
import { Text } from 'components/Text';
import { Button } from 'components/Button';
import { TextInput } from './private/inputs/TextInput';
import './FormEmail.scss';
/**
 * @component FormEmail
 * @since 1.0.0
 */
export function FormEmail(props) {
    let { name, size, style, picto, badge, label, tooltip, infos, error, required, optional, disabled, placeholder, clearable, prefix, suffix } = Object.assign({ size: 'medium', name: '', style: 'normal', picto: 'envelope' }, props);
    const form = useForm();
    const [ident] = useIdent('form-input');
    const [value, setValue] = useValue(name, props.value, props.defaultValue || '');
    const [focused, setFocused] = useState(false);
    const inputRef = useRef(null);
    /**
     * @function onClear
     * @since 1.0.0
     * @hidden
     */
    function onClear() {
        if (inputRef.current) {
            inputRef.current.value = '';
        }
        setValue('');
    }
    /**
     * @function onBlur
     * @since 1.0.0
     * @hidden
     */
    function onBlur() {
        setFocused(false);
    }
    /**
     * @function onFocus
     * @since 1.0.0
     * @hidden
     */
    function onFocus() {
        setFocused(true);
    }
    /**
     * @function onChange
     * @since 1.0.0
     * @hidden
     */
    function onChange(value, e) {
        var _a, _b;
        const values = e.currentTarget.value.split('@');
        const formattedValue = ((_a = values[0]) !== null && _a !== void 0 ? _a : '') + '@' + ((_b = values[1]) !== null && _b !== void 0 ? _b : '');
        if (!e.currentTarget.value.includes('@')) {
            e.currentTarget.value = formattedValue;
            setValue(formattedValue);
            e.currentTarget.selectionStart = formattedValue.length - 1;
            e.currentTarget.selectionEnd = formattedValue.length - 1;
        }
        else {
            e.currentTarget.value = formattedValue;
            setValue(formattedValue);
        }
    }
    useEffect(() => {
        var _a;
        if (inputRef.current) {
            inputRef.current.value = (_a = props.value) !== null && _a !== void 0 ? _a : '';
        }
    }, [inputRef, props.value]);
    useIf(focused, props.onFocus, props.onBlur);
    useWatch(() => {
        if (props.onChange) {
            props.onChange(value !== null && value !== void 0 ? value : '');
        }
    }, [value]);
    if (error == null) {
        error = form.getError(name);
    }
    const className = classNames('form-email', 'form-email--' + size, 'form-email--' + style, { 'form-email--is-required': required }, { 'form-email--is-optional': optional }, { 'form-email--is-disabled': disabled }, { 'form-email--is-focused': focused }, { 'form-email--has-label': label !== '' }, { 'form-email--has-value': value !== '' }, { 'form-email--has-picto': picto }, { 'form-email--has-badge': badge }, { 'form-email--has-error': error }, props.className);
    return (React.createElement("div", { className: className },
        React.createElement("div", { className: "form-email-field" },
            React.createElement("div", { className: "form-email-field-head" },
                label && (React.createElement(FormFieldLabel, { className: "form-email-label", style: style, label: label, ident: ident, tooltip: tooltip, required: required, optional: optional, disabled: disabled })),
                infos && (React.createElement(FormFieldInfos, { className: "form-email-infos", style: style, infos: infos }))),
            React.createElement("div", { className: "form-email-field-body" },
                prefix && React.createElement("div", { className: "form-email-prefix" }, prefix),
                React.createElement(TextInput, { ref: inputRef, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : t('example@example.com'), onChange: onChange, onBlur: onBlur, onFocus: onFocus, pattern: "[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+\\/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?" }),
                picto && React.createElement(Icon, { className: "form-email-picto", value: picto }),
                value && clearable && (React.createElement(Button, { className: "form-input-clear", style: "picto", picto: "fad circle-xmark", onPress: onClear })),
                badge && React.createElement(Text, { className: "form-email-badge", value: badge }),
                suffix && React.createElement("div", { className: "form-email-suffix" }, suffix))),
        React.createElement(FormFieldError, { error: error })));
}
